'use client';

import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';

interface DeleteTeamButtonProps {
  /** If present (and `canDelete`), the trash button is rendered. */
  onDelete?: () => void;
  canDelete?: boolean;
}

/**
 * Trash button shared by both participant tabs (confirmed teams and registrations).
 * It sits inside the clickable card header, so it stops the click from toggling
 * the accordion open.
 */
export function DeleteTeamButton({
  onDelete,
  canDelete,
}: DeleteTeamButtonProps) {
  if (!canDelete || !onDelete) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete?.();
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      className="ml-2 text-red-600 hover:bg-red-50 hover:text-red-700"
      title="Eliminar equipo"
    >
      <Trash2 className="h-4 w-4" />
    </Button>
  );
}
